import {
  ABANDONED_CART_DATA, ADDON_DATA, CHECKOUT_BRAND_DATA, CUSTOMER_DATA,
  DEPARTURE_SELECTED_DATA, DISCOUNT_SELECTED_DATA, PARTICIPANTS_DATA,
  PICKUPPOINT_SELECTED_DATA, VARIATION_SELECTED_DATA, CHECKOUT_SESSION_DATA
} from "../constants/GlobalConstants";
import ReactHtmlParser from 'react-html-parser';



export const utils = {
  getQueryParam(url) {

    var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
    var obj = {};

    if (queryString) {
      queryString = queryString.split('#')[0];
      var arr = queryString.split('&');

      for (var i = 0; i < arr.length; i++) {
        var a = arr[i].split('=');
        var paramName = a[0];
        var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

        paramName = paramName.toLowerCase();
        if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

        if (paramName.match(/\[(\d+)?\]$/)) {
          var key = paramName.replace(/\[(\d+)?\]/, '');
          if (!obj[key]) obj[key] = [];

          if (paramName.match(/\[\d+\]$/)) {
            var index = /\[(\d+)\]/.exec(paramName)[1];
            obj[key][index] = paramValue;
          } else {
            obj[key].push(paramValue);
          }
        } else {
          if (!obj[paramName]) {
            obj[paramName] = paramValue;
          } else if (obj[paramName] && typeof obj[paramName] === 'string') {
            obj[paramName] = [obj[paramName]];
            obj[paramName].push(paramValue);
          } else {
            obj[paramName].push(paramValue);
          }
        }
      }
    }

    return obj;
  },
  getQueryParamWithEncryption(url) {

    var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
    var obj = {};

    if (queryString) {
      queryString = queryString.split('#')[0];
      var arr = queryString.split('&');

      for (var i = 0; i < arr.length; i++) {
        var a = arr[i].split('=');
        var paramName = a[0];
        var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];
        let updatedParam = [];
        if (a.length > 2) {
          updatedParam = a.map(function (d, ind) {

            if (ind > 1)
              return "=";
            else
              return "";
          });
        }
        paramValue += updatedParam.length > 0 ? updatedParam.join().replace(/,/g, '') : "";
        paramName = paramName;
        if (typeof paramValue === 'string') paramValue = paramValue;

        if (paramName.match(/\[(\d+)?\]$/)) {
          var key = paramName.replace(/\[(\d+)?\]/, '');
          if (!obj[key]) obj[key] = [];

          if (paramName.match(/\[\d+\]$/)) {
            var index = /\[(\d+)\]/.exec(paramName)[1];
            obj[key][index] = paramValue;
          } else {
            obj[key].push(paramValue);
          }
        } else {
          if (!obj[paramName]) {
            obj[paramName] = paramValue;
          } else if (obj[paramName] && typeof obj[paramName] === 'string') {
            obj[paramName] = [obj[paramName]];
            obj[paramName].push(paramValue);
          } else {
            obj[paramName].push(paramValue);
          }
        }
      }
    }

    return obj;
  },
  UrlUpdating(props, allAppliedfilters) {
    const where = this.getWhereIds(allAppliedfilters.where);
    const when = this.getWhenIds(allAppliedfilters.when);
    const type = this.getTypeIds(allAppliedfilters.type);
    const level = this.getLevelIds(allAppliedfilters.level);
    const length = this.getLengthIds(allAppliedfilters.length);
    const capacity = allAppliedfilters.capacity ? allAppliedfilters.capacity : 1;
    const page = allAppliedfilters.page ? allAppliedfilters.page : 1;


    const startDate = allAppliedfilters.selectedDeparture.startDate && (new Date(decodeURIComponent(allAppliedfilters.selectedDeparture.startDate)).toString().indexOf('Invalid') === -1) ? new Date(allAppliedfilters.selectedDeparture.startDate) : '';
    const endDate = allAppliedfilters.selectedDeparture.endDate && (new Date(decodeURIComponent(allAppliedfilters.selectedDeparture.endDate)).toString().indexOf('Invalid') === -1) ? new Date(allAppliedfilters.selectedDeparture.endDate) : '';
    const { history, match } = props;
    const isliked = match.params && match.params.like && match.params.like.toLowerCase() === "wishlist";
    if (startDate && endDate) {
      const formattedStartDate = this.encodeUri(`${(startDate.getMonth() + 1)}-${startDate.getDate()}-${startDate.getFullYear()}`);
      const formattedEndDate = this.encodeUri(`${(endDate.getMonth() + 1)}-${endDate.getDate()}-${endDate.getFullYear()}`);
      let filterurl = isliked ? `${props.homepage}filter/where-${where}/when-${when}/type-${type}/length-${length}/level-${level}/a-${capacity}/${formattedStartDate}/${formattedEndDate}/wishlist/page-${page}` :
        `${props.homepage}filter/where-${where}/when-${when}/type-${type}/length-${length}/level-${level}/a-${capacity}/${formattedStartDate}/${formattedEndDate}/0/page-${page}`;;

      history.push({
        pathname: filterurl
      })
    } else {

      const filterurl = isliked ? `${props.homepage}filter/where-${where}/when-${when}/type-${type}/length-${length}/level-${level}/a-${capacity}/0/0/wishlist/page-${page}` :
        `${props.homepage}filter/where-${where}/when-${when}/type-${type}/length-${length}/level-${level}/a-${capacity}/0/0/0/page-${page}`;

      history.push({
        pathname: filterurl
      })
    }


  },

  getWhereIds(where) {
    const selectedWhere = where.selectedWhere ? where.selectedWhere : 0;
    if (selectedWhere <= 0) {
      return 0;
    }
    return selectedWhere.join('-');
  },
  getWhenIds(when) {
    const selectedWhen = when.selectedWhen ? when.selectedWhen : 0;
    if (selectedWhen === 0) {
      return 0;
    }
    return selectedWhen.join('-');
  },
  getTypeIds(type) {
    const selectedType = (type.selectedType && !isNaN(type.selectedType)) ? type.selectedType : 0;
    if (selectedType === 0) {
      return 0;
    }
    return selectedType;
  },
  getLevelIds(level) {

    const selectedLevel = level.selectedLevel ? level.selectedLevel : 0;
    if (selectedLevel === 0) {
      return 0;
    }
    return selectedLevel.join('-');
  },
  getLengthIds(length) {
    const selectedLength = length.selectedLength ? length.selectedLength : 0;
    if (selectedLength === 0) {
      return 0;
    }
    return selectedLength.join('-');
  },

  checkWithParam(filtername, value, params) {
    //////;
    const filtersfromurl = this.getfilteronprops(filtername, params);
    // ////;
    if (filtersfromurl && filtersfromurl.length > 0) {
      return (filtersfromurl.findIndex(x => x === value) > -1);
    }
    return false;
  },
  getfilteronprops(filtername, params) {
    if (filtername) {


      switch (filtername) {
        case `Where`:
          return params.where.split('-')

        case `When`:
          return params.when.split('-')

        case `Length`:
          return params.length.split('-')

        case `Level`:
          return params.level.split('-')

        case `Type`:
          return params.type.split('-')

        default:
          break;
      }
    } else {
      // ////;
      const currentCapacity = params.adult.split('-').filter(x => x > 0);
      return {
        "selectedWhere": params.where.split('-').filter(x => x > 0),
        "selectedWhen": params.when.split('-').filter(x => x > 0),
        "selectedLevel": params.level.split('-').filter(x => x > 0),
        "selectedLength": params.length.split('-').filter(x => x > 0),
        "selectedType": params.type.split('-').filter(x => x > 0),
        "selectedCapacity": Array.isArray(currentCapacity) ? currentCapacity[0] : currentCapacity,
        "selectedDeparture": { startDate: (params.start ? params.start : ''), endDate: (params.end ? params.end : '') }

      }
    }
  },
  getFilterFromParam(params) {

    let tripRequestModel = {
      When: [],
      Where: [],
      Length: [],
      Level: [],
      Type: [],
      Participants: { Adult: 1, Youth: 0, Childrens: 0, Infants: 0 },
      Date: {
        StartDate: '',
        EndDate: ''
      },
      Brandid: document.getElementById("hdBrand").value,
      Language: document.getElementById("hdLanguage").value,
      Page: "1"
    }
    const when = params.when ? (params.when.split('-') && params.when.split('-').length > 0 ? params.when.split('-').filter(x => !isNaN(x) && x > 0) : []) : [];
    const where = params.where ? (params.where.split('-') && params.where.split('-').length > 0 ? params.where.split('-').filter(x => !isNaN(x) && x > 0) : []) : [];
    const level = params.level ? (params.level.split('-') && params.level.split('-').length > 0 ? params.level.split('-').filter(x => !isNaN(x) && x > 0) : []) : [];
    const length = params.length ? (params.length.split('-') && params.length.split('-').length > 0 ? params.length.split('-').filter(x => !isNaN(x) && x > 0) : []) : [];
    const type = params.type ? (params.type.split('-') && params.type.split('-').length > 0 ? params.type.split('-').filter(x => !isNaN(x) && x > 0) : []) : [];
    let adult = params.adult ? (params.adult.split('-') && params.adult.split('-').length > 0 ? params.adult.split('-').filter(x => !isNaN(x) && x > 0) : 1) : 1;
    adult = (Array.isArray(adult) && adult.findIndex(x => x > 0) > -1) ? adult[0] : "1";
    const Participants = { ...tripRequestModel.Participants, Adult: adult }
    const selectedDeparture = {
      startDate: (params.start && params.start !== undefined && params.start !== "0" && (new Date(params.start).toString().indexOf('Invalid') === -1) ?
        new Date(params.start).toLocaleDateString("en-US") : null),
      endDate: (params.end && params.end !== undefined && params.end !== "0" && (new Date(params.end).toString().indexOf('Invalid') === -1) ?
        new Date(params.end).toLocaleDateString("en-US") : null)
    };
    const page = params.page ? params.page.split('-')[1] : "1";
    const updateddate = { ...tripRequestModel.Date, StartDate: selectedDeparture.startDate, EndDate: selectedDeparture.endDate }
    const isLike = params && params.like && params.like === "wishlist";
    const likedProducts = isLike ? this.getLikedProducts() : null;
    tripRequestModel = {
      ...tripRequestModel, When: when, Where: where, Type: type, Length: length, Level: level, Participants: Participants, Date: updateddate, page: page
      , likedProducts: likedProducts
    }
    return tripRequestModel;

  },
  getDaterangefromParams(params) {
    //;
    const startDate = (params.start && params.start !== undefined && params.start !== "0" && (new Date(params.start).toString().indexOf('Invalid') === -1) ? new Date(params.start) : '');
    const endDate = (params.end && params.end !== undefined && params.end !== "0" && (new Date(params.end).toString().indexOf('Invalid') === -1) ? new Date(params.end) : '');

    return { startDate: startDate && startDate !== "" ? new Date(startDate) : null, endDate: endDate && endDate !== "" ? new Date(endDate) : null }
  },
  getCurrentPage(params) {
    return params.page ? params.page.split('-')[1] : "1";
  },
  getAppliedFilterCount(where, when, type, level, length, startdate, enddate) {
    //////debugger;
    let clearFilterModel = {
      when: [],
      where: [],
      level: [],
      type: [],
      length: [],
      totalCount: 0
    }
    let totalAppliedfilterscount = 0;
    if (where) {
      const { filters = [], selectedWhere = [] } = where;
      filters.filter((data, index) => {
        if (selectedWhere && selectedWhere.findIndex(x => x === data.value) > -1) {
          clearFilterModel.where.push({ name: data.name, value: data.value });
          clearFilterModel.totalCount += 1;;
        }
      });
    }
    if (when) {
      const { filters = [], selectedWhen = [] } = when;
      filters.filter((data, index) => {
        if (selectedWhen && selectedWhen.findIndex(x => x === data.value) > -1) {
          clearFilterModel.when.push({ name: data.name, value: data.value });
          clearFilterModel.totalCount += 1;
        }
      });
    }
    if (level) {
      const { filters = [], selectedLevel = [] } = level;
      filters.filter((data, index) => {
        if (selectedLevel && selectedLevel.findIndex(x => x === data.value) > -1) {
          clearFilterModel.level.push({ name: data.name, value: data.value });
          clearFilterModel.totalCount += 1;
        }
      });
    }
    if (type) {
      const { filters = [], selectedType = [] } = type;
      filters.filter((data, index) => {
        if (selectedType && selectedType.findIndex(x => x === data.value) > -1) {
          clearFilterModel.type.push({ name: data.name, value: data.value });
          clearFilterModel.totalCount += 1;
        }

      });
    }
    if (length) {
      const { filters = [], selectedLength = [] } = length;
      filters.filter((data, index) => {
        if (selectedLength && selectedLength.findIndex(x => x === data.value) > -1) {
          clearFilterModel.length.push({ name: data.name, value: data.value });
          clearFilterModel.totalCount += 1;
        }
      });
    }
    if (startdate && startdate !== "0" && enddate && enddate !== "0") {
      clearFilterModel.totalCount += 1;
    }
    return clearFilterModel;
  },
  isUrlEncoded(url) {
    return url !== decodeURIComponent(url);
  },
  encodeUri(uri) {
    if (this.isUrlEncoded(uri)) {
      return uri;
    }
    else {
      return encodeURIComponent(uri);
    }
  },
  emailRegex() {
    //return /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/igm;
    //return new RegExp(`^[a-z0-9_\+-]+(\.[a-z0-9_\+-]+)*@[a-z0-9-]+(\.[a-z0-9]+)*\.([a-z]{2,4})$`);
    //return new RegExp(`^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$`)
    return /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
  },
  telRegex(pattern) {
    return new RegExp(pattern);
  },
  replaceSpecialNumberCharacters(value) {
    value = value.trimStart();
    return value.replace(/[!@#$%^&*(=+/1234569870,'{><_"}[;:?~`)]/g, "");
  },
  replaceSpecialCharactersForPhone(value) {
    value = value.trimStart();
    return value.replace(/[!@#$%^&*(=+/,'{><_"}[;:?~`)]/g, "").replace(/[a-zA-Z]+/g, '');;
  },
  replaceSpecialCharacters(value) {
    value = value.trimStart();
    return value.replace(/[!{@_}#$\|%.><;(:^&)+=*-]/g, "");
  },
  getUTCDateasLocale(d) {
    const currentDate = new Date(d);
    const currentLanguage = document.getElementById("hdLanguage").value;
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1;
    const day = currentDate.getDate();
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const utcDate = new Date(Date.UTC(year, month, day, 0, 0, 0));
    return utcDate.toLocaleDateString(currentLanguage, options)

  },
  getDateForCulture(d, options) {
    const currentDate = new Date(d);
    const currentLanguage = document.getElementById("hdLanguage").value;
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const day = currentDate.getDate();
    if (!options)
      options = { year: 'numeric', month: 'long', day: 'numeric' };

    const utcDate = new Date(Date.UTC(year, month, day, 0, 0, 0));
    return utcDate.toLocaleDateString(currentLanguage, options)
  },
  getLanguageforClaender() {
    const currentLanguage = document.getElementById("hdLanguage").value;
    if (currentLanguage === "en-Us")
      return "enUS"
    else if (currentLanguage === "da-DK")
      return "da"
  },
  getPriceasCurrencyFormat(amount, currency = {}) {

    const currentLanguage = document.getElementById("hdLanguage").value;
    const formatAsCurrency = this.formatAsCurrency;
    const injectCurrencySymbol = this.injectCurrencySymbol;
    const currencySymbol = currency.currencySymbol;
    const position = currency.currencyArrangementId;
    if (!currencySymbol) {

      if (currentLanguage === `en-US`) {
        return formatAsCurrency(`en-US`, 'USD', amount)
      } else if (currentLanguage === `da`) {
        return formatAsCurrency(`da-DK`, 'DKK', amount)
      } else {
        return formatAsCurrency(`en-US`, 'USD', amount)
      }

    }
    else {
      let formattedAmount = formatAsCurrency(currentLanguage, currency.currencyInternational, amount);

      if (position === 0 || position === 1) {
        formattedAmount = formattedAmount.replace(/[^\d,.]/g, '');
        if (amount < 0) {
          formattedAmount = "-" + formattedAmount;
        }
        formattedAmount = formattedAmount.replace(/^\./, "");
        formattedAmount = formattedAmount.replace(/\.$/, "");
        return injectCurrencySymbol(position, currencySymbol, formattedAmount);

      } else {
        return `${formattedAmount} `;
      }
    }
  },
  formatAsCurrency(culture, currency, amount) {

    const amountAsCurrency = `${new Intl.NumberFormat(culture, {
      style: 'currency', currency: currency, maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    }).format(amount)}`;
    return amountAsCurrency.replace(/\.$/, "");
  },
  injectCurrencySymbol(position, currencySymbol, currencyAmount) {
    let formattedAmount = currencyAmount;
    if (position === 0) {
      return `${currencySymbol} ${formattedAmount}`;
    } else if (position === 1) {
      return `${formattedAmount} ${currencySymbol} `;
    } else {
      return `${formattedAmount} ${currencySymbol} `;
    }
  },
  getLikedProducts() {
    var nameEQ = "t_Likes" + "=";
    var ca = document.cookie.split(';');
    var likedProductsCookie = null;
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) {
        likedProductsCookie = c.substring(nameEQ.length, c.length);
        if (likedProductsCookie) {
          likedProductsCookie = likedProductsCookie.replace(/[^a-zA-Z0-9,]/g, '');
        }
      }

    }

    return likedProductsCookie ? likedProductsCookie : 0;
  },
  changeRouteOnVariationDep(history, props, variation, departure, capacity, step = 1) {

    const { checkoutUrl = ``, productDetails = {}, match = {} } = props;
    const { productId = ``, productMsId = `` } = productDetails;
    const { params = {} } = match;
    // const abandonedCartData =params.trackingid?params.trackingid: this.getSessionData(ABANDONED_CART_DATA);
    const nextStep = `${checkoutUrl}${productMsId}/${productId}/${departure}/${variation}/${capacity}/${step}/${params.trackingid}`
    history.replace(`${nextStep}`)
  },
  goToNextCheckoutStep(history, props, step = 1, trackingId) {

    const { checkoutUrl = ``, productDetails = {}, departureselected = {}, variationselected = {}, capacity = 1 } = props;
    const { productId = ``, productMsId = `` } = productDetails;
    const departureId = departureselected.value.departureId;
    const variationId = variationselected.value.variationMSId;
    if (trackingId) {
      const nextStep = `${checkoutUrl}${productMsId}/${productId}/${departureId}/${variationId}/${capacity}/${step}/${trackingId}`
      history.push(`${nextStep}`)
    } else {
      let formattedData = this.getSessionData(CHECKOUT_SESSION_DATA);
      const nextStep = `${checkoutUrl}${productMsId}/${productId}/${departureId}/${variationId}/${capacity}/${step}/${formattedData.trackingId}`
      history.push(`${nextStep}`)
    }

  },
  urlChangeOnParticipantOnChange(history, props, trackingId, participantCount) {
    const { checkoutUrl = ``, productDetails = {}, departureselected = {}, variationselected = {} } = props;
    const { productId = ``, productMsId = `` } = productDetails;
    const departureId = departureselected.value.departureId;
    const variationId = variationselected.value.variationMSId;
    if (trackingId) {
      const nextStep = `${checkoutUrl}${productMsId}/${productId}/${departureId}/${variationId}/${participantCount}/${2}/${trackingId}`
      history.push(`${nextStep}`)
    } else {
      let formattedData = this.getSessionData(CHECKOUT_SESSION_DATA);
      const nextStep = `${checkoutUrl}${productMsId}/${productId}/${departureId}/${variationId}/${participantCount}/${2}/${formattedData.trackingId}`
      history.push(`${nextStep}`)
    }
  },
  saveSessionWithAllStepStatus(data, trackingId) {
    const formattedData = {
      ...formattedData, brandData: data, trackingId: trackingId ? trackingId : formattedData.trackingId, lastupdate: new Date(),
      step_one: true, step_two: true, step_three: true
    };
    const jsonStrData = JSON.stringify(formattedData);
    localStorage.setItem(CHECKOUT_SESSION_DATA, jsonStrData);
  },
  saveSessionData(key, data, trackingId) {
    let formattedData = this.getSessionData(CHECKOUT_SESSION_DATA);

    if (key === CHECKOUT_BRAND_DATA) {
      formattedData = { ...formattedData, brandData: data, trackingId: trackingId ? trackingId : formattedData.trackingId, lastupdate: new Date() };

    } else if (key === ABANDONED_CART_DATA) {
      const { response = {} } = data;
      const { trackingId = `` } = response;
      formattedData = { ...formattedData, adandonedData: data, trackingId: trackingId, lastupdate: new Date() };
    }
    else if (key === CUSTOMER_DATA) {
      formattedData = { ...formattedData, customerData: data, lastupdate: new Date() };
    }
    else if (key === PARTICIPANTS_DATA) {
      formattedData = { ...formattedData, participantsData: data };
    }
    else if (key === ADDON_DATA) {
      formattedData = { ...formattedData, addonData: data, lastupdate: new Date() };
    }
    else if (key === DEPARTURE_SELECTED_DATA) {
      formattedData = { ...formattedData, departureSelectedData: data, lastupdate: new Date() };
    }
    else if (key === VARIATION_SELECTED_DATA) {
      formattedData = { ...formattedData, variationSelectedData: data, lastupdate: new Date() };
    }
    else if (key === PICKUPPOINT_SELECTED_DATA) {
      formattedData = { ...formattedData, pickupPointSelectedData: data, lastupdate: new Date() };
    }
    else if (key === DISCOUNT_SELECTED_DATA) {
      formattedData = { ...formattedData, discountData: data, lastupdate: new Date() };
    }
    const jsonStrData = JSON.stringify(formattedData);
    localStorage.setItem(CHECKOUT_SESSION_DATA, jsonStrData);
  },
  getSessionData(key, trackingId) {

    const sessionData = localStorage.getItem(CHECKOUT_SESSION_DATA);

    ////debugger;
    let formattedData = sessionData ? JSON.parse(sessionData) : null;
    if (trackingId && formattedData.trackingId === trackingId) {
      return null
    }
    if (!sessionData) {
      return null;
    }
    if (key === CHECKOUT_BRAND_DATA) {
      return formattedData.brandData;

    } else if (key === ABANDONED_CART_DATA) {
      return formattedData.adandonedData;
    }
    else if (key === CUSTOMER_DATA) {
      return formattedData.customerData;
    }
    else if (key === PARTICIPANTS_DATA) {
      return formattedData.participantsData;
    }
    else if (key === ADDON_DATA) {
      return formattedData.addonData;
    }
    else if (key === DEPARTURE_SELECTED_DATA) {
      return formattedData.departureSelectedData;
    }
    else if (key === VARIATION_SELECTED_DATA) {

      return formattedData.variationSelectedData;
    }
    else if (key === PICKUPPOINT_SELECTED_DATA) {
      return formattedData.pickupPointSelectedData;
    }
    else if (key === DISCOUNT_SELECTED_DATA) {
      return formattedData.discountData;
    }
    return formattedData;

  },
  newCheckoutSession(existingTrackingId, step, isUpdateSessionWithNavStatus) {

    const sessionData = localStorage.getItem(CHECKOUT_SESSION_DATA);

    let formattedData = JSON.parse(sessionData) || {};
    const { trackingId = `` } = formattedData;
    if ((existingTrackingId || existingTrackingId == "0") && trackingId !== existingTrackingId)
      localStorage.clear();

    if (step === 0 | step === 1)
      this.saveSessionWithStepStatus(step, isUpdateSessionWithNavStatus);



  },
  saveSessionWithStepStatus(step, isUpdate) {
    let formattedData = this.getSessionData(CHECKOUT_SESSION_DATA);
    if (!isUpdate) {
      if (step === 0) {
        formattedData = { ...formattedData, step_one: false, step_two: false, step_three: false };
      }
      else if (step === 1)
        formattedData = { ...formattedData, step_one: true };
      else if (step === 2)
        formattedData = { ...formattedData, step_two: true };
      else if (step === 3)
        formattedData = { ...formattedData, step_three: true };

      const jsonStrData = JSON.stringify(formattedData);
      localStorage.setItem(CHECKOUT_SESSION_DATA, jsonStrData);
    } else {
      if (step === 0) {
        formattedData = { ...formattedData, step_one: false, step_two: false };
      }
      else if (step === 1) {
        formattedData = { ...formattedData, step_one: true, step_two: false };
      }
      else if (step === 4) {
        formattedData = { ...formattedData, step_one: true, step_two: true };
      }
      const jsonStrData = JSON.stringify(formattedData);
      localStorage.setItem(CHECKOUT_SESSION_DATA, jsonStrData);
    }
  },
  getSessionStatus(step) {
    let formattedData = this.getSessionData(CHECKOUT_SESSION_DATA);
    if (step === 1)
      return formattedData.step_one;
    else if (step === 2)
      return formattedData.step_one;
    else if (step === 3)
      return formattedData.step_two;
    else if (step === 4)
      return formattedData.step_one && formattedData.step_two && formattedData.step_three;
  },
  clearSession() {
    localStorage.clear();
  }, getProductDetailParams(props) {
    const productPageId = props.contentid.replace(/[!@#$%^&*(=+/,'{><_"}[;:?~`)]/g, "").replace(/[a-zA-Z]+/g, '').replace("-", "");
    const brandId = props.brandid.replace(/[!@#$-%^&*(=+/,'{><_"}[;:?~`)]/g, "").replace(/[a-zA-Z]+/g, '').replace("-", "");
    return { productPageId: Number(productPageId), brandId: Number(brandId), culture: document.getElementById("hdLanguage").value };
  },
  getCurrentProductUrl(pageUrls, currentLanguage) {

    try {
      if (pageUrls) {


        var parsedUrls = JSON.parse(pageUrls);
        const updatedUrl = parsedUrls.filter(({ Culture, Url, Id }) => {
          if (Culture && currentLanguage && Culture.toLowerCase() === currentLanguage.toLowerCase())
            return Url;
        });
        return updatedUrl[0];
      }
      return `#`
    } catch {
      return `#`;
    }
  },
  isDateValid(date) {
    try {
      if (date) {
        const newDate = new Date(date);
        if (Object.prototype.toString.call(newDate) === "[object Date]" && (newDate instanceof Date)) {
          return true;
        }

      }
      return false;
    } catch (error) {
      return false;
    }


  },
  convertToDateWithoutTime(birthDay) {

    let date = birthDay;

    date = date.substring(0, 10).replace(/[&\/\\#-,~.:*]/g, '-').split('-')
    date = date[0] + '-' + date[1] + '-' + date[2];
    return new Date(date);

  },
  updateAdultCount(count) {
    document.getElementById(`hdadultadult`).value = count;
  },
  removeNavFromCheckoutPages() {

    if (document.getElementById("root"))
      document.getElementById("root").style.paddingTop = 0;

    if (document.getElementById("newNavbar"))
      document.getElementById("newNavbar").style.display = 'none';

    if (document.getElementsByTagName('footer') && document.getElementsByTagName('footer').length > 0)
      document.getElementsByTagName('footer')[0].style.display = "none";
    if (document.getElementById("beforefooterblock"))
      document.getElementById("beforefooterblock").style.display = "none";
    document.body.style.opacity = "1";

    if (document.getElementsByClassName("loader-wrapper")[0])
      document.getElementsByClassName("loader-wrapper")[0].style.display = "none";

    setTimeout(function () {
      if (window.jQuery) {
        window.jQuery('html, body').animate({ scrollTop: 0 }, 'fast', function () {
        })
      }
    }, 250);

  },
  returnAsHtml(htmlString) {
    return ReactHtmlParser(htmlString);
  }
}